export default __webpack_public_path__ + "static/media/xvs.0caca121.svg";